import React, { memo } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { IPricingTypes } from 'types/graphqlTypes'
import {
  EQUIPMENT_TYPE_OPTIONS,
  TRUE_RATE_EQUIPMENT_TYPE_OPTIONS,
} from 'apps/rms/constants/shipperRates'
import { IShipperRate, EQUIPMENT_TYPE } from 'apps/rms/types/shipperRates'

interface IEquipmentTypeProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
  error?: string
}

export const EquipmentType = memo<IEquipmentTypeProps>(
  ({ error, onChange, value: { equipment, pricingType } }) => {
    const equipmentKey = equipment?.key
    const equipmentTypeHandler = (e: ISelectOption<EQUIPMENT_TYPE>) => {
      onChange({ equipment: { key: e.value } })
    }

    return (
      <div className='col-md-4 col-xs-4'>
        <Select
          label='Equipment Type'
          options={
            pricingType === IPricingTypes.variable
              ? TRUE_RATE_EQUIPMENT_TYPE_OPTIONS
              : EQUIPMENT_TYPE_OPTIONS
          }
          value={equipmentKey}
          onChange={equipmentTypeHandler}
          dataTest='modal-equipment-type'
          required
          validationMessage={error}
          invalid={!!error}
        />
      </div>
    )
  }
)
